<template>
  <div>
    <div if="validation-fail-outer">
      <div id="validation-fail" v-show="validationFail">
        <div
          v-for="message in validationFailMessages"
          :key="message"
          class="validationFailMessage">
            {{ message }}
        </div>
      </div>
    </div>
    <div class="user-info-item right">
      <el-input
        class="user-info-input"
        v-model="firstName"
        @blur="validate"
        placeholder="First Name">
      </el-input>
    </div>

    <div class="user-info-item left">
      <el-input
        class="user-info-input"
        v-model="lastName"
        @blur="validate"
        placeholder="Last Name">
      </el-input>
    </div>

    <div class="user-info-item right">
      <el-input
        @focus="setPhoneKeys"
        @blur="validate"
        v-model="phone"
        type="tel"
        v-mask="['###-###-####']"
        class="user-info-input phone-input"
        placeholder="Phone Number">
      </el-input>
    </div>

    <div class="user-info-item left">
      <el-input
        @focus="setPhoneKeys"
        @blur="validate"
        v-model="phoneConfirmation"
        type="tel"
        v-mask="['###-###-####']"
        class="user-info-input phone-input"
        placeholder="Confirm Phone Number">
      </el-input>
    </div>

    <div class="user-info-item right">
      <el-input
        class="user-info-input"
        @blur="validate"
        v-model="email"
        placeholder="Email">
      </el-input>
    </div>

    <div class="user-info-item left">
      <el-input
        class="user-info-input"
        @blur="validate"
        v-model="emailConfirmation"
        placeholder="Confirm Email">
      </el-input>
    </div>

    <div class="user-info-item right">
      <occasionPicker
        class="user-info-input"
        v-on:occasionChange="occasionChange">
      </occasionPicker>
    </div>

    <div class="user-info-item right">
      <cakePicker
        v-show="occasion"
        class="user-info-input"
        v-on:cakeChange="cakeChange">
      </cakePicker>
    </div>

  </div>
</template>

<script>

import occasionPicker from '@comp/occasionPicker'
import cakePicker from '@comp/cakePicker'
import { mask } from 'vue-the-mask'

function phoneKeypressEventHandler( event ) {
  let charCode = event.charCode

  if ( ( charCode >= 48 && charCode <= 57 ) || charCode == 45 || charCode == 40 || charCode == 41 ) { } else {
    event.preventDefault()
  }
}

export default {
  name: "infoUser",
  directives: {
    mask
  },
  components: {
    occasionPicker,
    cakePicker,
  },
  props: [ ],
  data() {
    return {
    }
  },
  computed: {
    validationFail() {
      let vf = this.$store.state.userInfo.validationFailure
      return _.some( _.filter( vf, f => f != 'policyAccepted' ) , v=> v )
    },
    validationFailMessages() {
      let messages = []
      _.forEach( [ 'firstName', 'lastName', 'email', 'emailConfirmation', 'phone', 'phoneConfirmation' ], v => {
        if ( _.includes( this.$store.state.userInfo.validationFailure, v ) ) {
          if ( v.includes( "Confirmation" ) ) {
            messages.push( _.startCase( v ) + ' must match' )
          } else {
            messages.push( _.startCase( v ) + ' is not valid' )
          }
        }
      } )

      //message about policy

      return messages
    },
    occasion() {
      return this.$store.state.userInfo.occasion
    },
    firstName:{
      get() {
        return this.$store.state.userInfo.firstName
      },
      set( val ) {
        let firstName = val.trim()
        this.$store.commit( 'userInfo/UPDATE_FIRST_NAME', firstName )
      }
    },
    lastName: {
      get() {
        return this.$store.state.userInfo.lastName
      },
      set( val ) {
        let lastName = val.trim()
        this.$store.commit( 'userInfo/UPDATE_LAST_NAME', lastName )
      }
    },
    phone: {
      get() {
        return this.$store.state.userInfo.phone
      },
      set( val ) {
        this.$store.commit( 'userInfo/UPDATE_PHONE', val )
      }
    },
    phoneConfirmation: {
      get() {
        return this.$store.state.userInfo.phoneConfirmation
      },
      set( val ) {
        this.$store.commit( 'userInfo/UPDATE_PHONE_CONFIRMATION', val )
      }
    },
    email: {
      get() {
        return this.$store.state.userInfo.email
      },
      set( val ) {
        let email = val.trim()
        this.$store.commit( 'userInfo/UPDATE_EMAIL', email )
      }
    },
    emailConfirmation: {
      get() {
        return this.$store.state.userInfo.emailConfirmation
      },
      set( val ) {
        let email = val.trim()
        this.$store.commit( 'userInfo/UPDATE_EMAIL_CONFIRMATION', email )
      }
    },
  },
  methods: {
    setPhoneKeys() {
      if ( !this.phoneElement ) {
        this.phoneElement = document.querySelector( '.phone-input > input' )
        this.phoneElement.addEventListener( 'keypress', phoneKeypressEventHandler, false )
      }
    },
    cakeChange( val ) {
      // this.$store.commit( 'userInfo/UPDATE_CAKE', val )
    },
    occasionChange( val ) {
      if ( val == null ) {
        this.$store.commit( 'userInfo/UPDATE_CAKE', 'false' )
      }
    },
    validate() {
      if ( this.$store.state.userInfo.validationFailure.length > 0 ) {
        this.$store.dispatch( 'userInfo/validate' )
      }
    }
  }
}

</script>

<style scoped lang="scss">

.user-info-item {
  display: inline-block;
  margin: 2px 0;
  // border: 1px solid purple;
  width: 49.5%;
  @media screen and (max-width: 425px) {
    margin: 10px 0;
    width: 100%;
  }
}

.left {
 text-align: left;
}

.right {
  text-align: right;
}

.user-info-item-label {
  float: left;
  font-weight: bold;
}

.user-info-input {
  width: 200px;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
}

#validation-fail-outer {
  width: 100%;

}

#validation-fail {
  display: inline-block;
  margin: 15px auto;
  color: red;
  border: 1px solid red;
  border-radius: 5px;
  padding: 10px;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
}

.validationFailMessage {
  width: 100%;
}

</style>